<template>
    <div class="py-4">
        <header class="pb-4">
            <div class="container-fluid">
                <div class="row align-items-end">
                    <div class="col-sm col-12">
                        <h1 class="h2 ls-tight">Calculadora</h1>
                    </div>
                </div>
            </div>
            <div class="border-bottom">
                <v-tabs v-model="tab" @change="CHANGE()">
                    <v-tab :key="'global'">General</v-tab>
                    <v-tab :key="'fixed-price'">Precios fijos</v-tab>
                    <v-tab :key="'shipping'">Envío</v-tab>
                    <v-tab :key="'nationalization'">Nacionalización</v-tab>
                    <v-tab :key="'handling'">Manejo</v-tab>
                    <v-tab :key="'insurance'">Seguro</v-tab>
                    <v-tab :key="'storage'">Almacenamiento</v-tab>
                </v-tabs>
            </div>
        </header>
        <main>
            <div class="container-fluid">
                <div class="vstack gap-4">
                    <v-tabs-items v-model="tab">
                        <v-tab-item :key="'global'">
                            <global v-if="tab == 0"/>
                        </v-tab-item>
                        <v-tab-item :key="'fixed-price'">
                            <fixed-price v-if="tab == 1"/>
                        </v-tab-item>
                        <v-tab-item :key="'shipping'">
                            <shipping v-if="tab == 2"/>
                        </v-tab-item>
                        <v-tab-item :key="'nationalization'">
                            <nationalization v-if="tab == 3"/>
                        </v-tab-item>
                        <v-tab-item :key="'handling'">
                            <handling v-if="tab == 4"/>
                        </v-tab-item>
                        <v-tab-item :key="'insurance'">
                            <insurance v-if="tab == 5"/>
                        </v-tab-item>
                        <v-tab-item :key="'storage'">
                            <storage v-if="tab == 6"/>
                        </v-tab-item>
                    </v-tabs-items>
                </div>
            </div>
        </main>
    </div>
</template>
<script>
import Global from "./cards/Global";
import Shipping from "./cards/Shipping";
import Nationalization from "./cards/Nationalization";
import Handling from "./cards/Handling";
import Insurance from "./cards/Insurance";
import Storage from "./cards/Storage";
import FixedPrice from "./cards/FixedPrice";
export default {
    components: { Global, Shipping, Nationalization, Handling, Insurance, Storage, FixedPrice },
    data(){
        return{
            tab: Number(localStorage.getItem('tab_calculator_update') | 0),
        }
    },
    methods: {
        CHANGE: function() {
            let vue = this
            localStorage.setItem('tab_calculator_update', vue.tab)
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/pages/settings/calculator/Index.vue